<template class="relative">
  <div class="relative">
    <Transition name="fade">
      <div class=" absolute inset-0 bg-grey-light bg-opacity-50" v-if="loading"></div>
    </Transition>
    <slot></slot>
    <Transition name="fade">
      <div role="status" class="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2" v-if="loading">
        <IconLoading class="w-10 h-10 mr-2 text-grey-dark fill-primary"/>
        <span class="sr-only">Loading...</span>
      </div>
    </Transition>
  </div>

</template>
<script setup lang="ts">
import IconLoading from "@/components/icons/IconLoading.vue";

defineProps({
  loading: {
    type: Boolean,
    default: false
  }
});
</script>
